module.exports = __webpack_public_path__ + "static/media/img_Inscription_syuku@2x.7e2878b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@2x/img_Inscription_syuku@2x.png
// module id = 977
// module chunks = 0